var render = function render(){var _vm=this,_c=_vm._self._c;return _c('generic-error',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Erreur dans l'URL")]},proxy:true}])},[_c('h1',[_vm._v("Oh oh ! 🙁")]),_c('p',[_vm._v("Aucune facture n'a été trouvée avec cet identifiant.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }